import { post } from 'libs/GrebbCommerceAPI/util';

export default async (basketId, country) => {
    const data = {
        country,
    };

    return await post(`/basket/${basketId}/payment-fields`, data);
};
